<p-toast></p-toast>

<div class="full-screen">
    <div class="col-12 form-container" *ngIf="loadData">
        <h2 class="title">Necesitamos unos datos más...</h2>
        <p class="subtitle">
            Para poder ofrecer o buscar propiedades y garantizar que eres un humano real, necesitamos unos datos para verificar tu identidad.
        </p>

        <form [formGroup]="personalForm" (ngSubmit)="onSubmit()" novalidate>
            <!-- Documento de Identidad -->
            <div class="col-12">
                <label class="label">Documento de Identidad</label>
                <div class="form-group flex-row mt-3">
                    <p-dropdown
                        [options]="identityTypes"
                        formControlName="ctIdentityType"
                        placeholder="Seleccione un tipo de documento"
                        [filter]="true"
                        optionLabel="optionName"
                        optionValue="optionCode">
                    </p-dropdown>

                    <input
                        pInputText
                        id="identityNumber"
                        type="text"
                        class="form-control identity-input"
                        formControlName="identityNumber"
                        autocomplete="off"
                        inputmode="text"
                        placeholder="Número de C.I. / Pasaporte"
                        maxlength="20"
                        required/>
                </div>

                <div class="col-offset-3 error-message">
                    <ul class="text-danger list-unstyled" *ngIf="isNotDataValid || personalForm.controls['identityNumber'].dirty">
                        <li *ngFor="let error of getValidationMessages(personalForm.controls['identityNumber'], 'documento de identidad')">
                            <p-message severity="error" [text]="error" *ngIf="!personalForm.controls['identityNumber'].valid"></p-message>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Alias -->
            <div class="col-12">
                <label class="label">Alias (Cómo quieres que te llamemos)</label>
                <div class="form-group mt-3">
                    <input
                        pInputText
                        type="text"
                        class="form-control alias full-name-input"
                        formControlName="accountAlias"
                        placeholder="Alias"
                        autocomplete="off"
                        maxlength="50"
                        required/>
                    <div class="error-message">
                        <ul class="text-danger list-unstyled" *ngIf="isNotDataValid || personalForm.controls['accountAlias'].dirty">
                            <li *ngFor="let error of getValidationMessages(personalForm.controls['accountAlias'], 'alias')">
                                <p-message severity="error" [text]="error" *ngIf="!personalForm.controls['accountAlias'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Nombre Completo -->
            <div class="col-12">
                <label class="label">Nombre Completo (como viene en tu Identidad Oficial)</label>
                <div class="form-group mt-3">
                    <div class="flex-row wrap">
                        <input
                            pInputText type="text" class="form-control full-name-input"
                            formControlName="names" placeholder="Nombre(s)" autocomplete="off" maxlength="60" required/>

                        <input
                            pInputText type="text" class="form-control full-name-input"
                            formControlName="firstName" placeholder="Apellido Paterno" autocomplete="off" maxlength="60" required/>

                        <input
                            pInputText type="text" class="form-control full-name-input"
                            formControlName="secondName" placeholder="Apellido Materno" autocomplete="off" maxlength="60" required/>
                    </div>

                    <div class="flex-row" *ngIf="isNotDataValid">
                        <div class="error-message">
                            <ul class="text-danger list-unstyled" *ngIf="isNotDataValid || personalForm.controls['names'].dirty">
                                <li *ngFor="let error of getValidationMessages(personalForm.controls['names'], 'nombres')">
                                    <p-message severity="error" [text]="error" *ngIf="!personalForm.controls['names'].valid"></p-message>
                                </li>
                            </ul>
                        </div>
                        <div class="error-message">
                            <ul class="text-danger list-unstyled" *ngIf="isNotDataValid || personalForm.controls['firstName'].dirty">
                                <li *ngFor="let error of getValidationMessages(personalForm.controls['firstName'], 'apellido paterno')">
                                    <p-message severity="error" [text]="error" *ngIf="!personalForm.controls['firstName'].valid"></p-message>
                                </li>
                            </ul>
                        </div>
                        <div class="error-message">
                            <ul class="text-danger list-unstyled" *ngIf="isNotDataValid || personalForm.controls['secondName'].dirty">
                                <li *ngFor="let error of getValidationMessages(personalForm.controls['secondName'], 'apellido materno')">
                                    <p-message severity="error" [text]="error" *ngIf="!personalForm.controls['secondName'].valid"></p-message>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Fecha de Nacimiento -->
            <div class="col-12">
                <label class="label">Fecha de Nacimiento</label>
                <div class="form-group mt-3">
                    <p-calendar
                        formControlName="birthdate"
                        [touchUI]="true"
                        [readonlyInput]="true"
                        [showIcon]="true"
                        [monthNavigator]="true"
                        [yearNavigator]="true"
                        [yearRange]="yearRange"
                        dateFormat="dd/mm/yy"
                        placeholder="Fecha de Nacimiento">
                    </p-calendar>

                    <div class="error-message">
                        <ul class="text-danger list-unstyled" *ngIf="isNotDataValid || personalForm.controls['birthdate'].dirty">
                            <li *ngFor="let error of getValidationMessages(personalForm.controls['birthdate'], 'fecha de cumpleaños')">
                                <p-message severity="error" [text]="error" *ngIf="!personalForm.controls['birthdate'].valid"></p-message>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Número de WhatsApp -->
            <div class="col-12">
                <label class="label">Número de WhatsApp</label>
                <div class="form-group flex-row mt-3">
                    <p-dropdown
                        [options]="countryCodes"
                        formControlName="cellphoneExtension"
                        placeholder="Selecciona un país"
                        [filter]="true"
                        filterBy="label,value"
                        optionLabel="label"
                        optionValue="value">
                    </p-dropdown>

                    <input
                        pInputText
                        type="tel"
                        class="form-control whatsapp-input"
                        formControlName="cellphone"
                        inputmode="numeric"
                        autocomplete="tel"
                        placeholder="(1) 234 5678"
                        maxlength="15"
                        required/>
                </div>
                <div class="error-message">
                    <ul class="col-offset-3 text-danger list-unstyled" *ngIf="isNotDataValid || personalForm.controls['cellphone'].dirty">
                        <li *ngFor="let error of getValidationMessages(personalForm.controls['cellphone'], 'celular')">
                            <p-message severity="error" [text]="error" *ngIf="!personalForm.controls['cellphone'].valid"></p-message>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Quiero... -->
            <div class="col-12">
                <label class="label">Quiero...</label>
                <div class="radio-group" *ngIf="targetTypes?.length">
                    <p-radioButton
                        *ngFor="let type of targetTypes; trackBy: trackByOptionCode"
                        formControlName="ctAccountTarget"
                        [value]="type.optionCode"
                        [label]="type.optionName">
                    </p-radioButton>
                </div>
            </div>

            <!-- Mensaje de error del servicio -->
            <div class="col-12" *ngIf="showErrorDialog">
                <ul class="text-danger list-unstyled" style="margin-top: 5px">
                    <li>
                        <p-message severity="error" [text]="dialogCode + ' ' + dialogMessage"></p-message>
                    </li>
                </ul>
            </div>

            <!-- Botón de registro -->
            <div class="col-12 form-group flex justify-content-center">
                <button
                    pButton
                    type="submit"
                    class="p-button-rounded custom-button"
                    [disabled]="loading">
                    <span *ngIf="!loading">Crear cuenta</span>
                    <span *ngIf="loading">Creando...</span>
                    <i class="pi pi-arrow-right ml-2" *ngIf="!loading"></i>
                </button>

            </div>

            <div class="full-screen-spinner" *ngIf="loading">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </form>
    </div>
</div>
<p-toast></p-toast>
